"use client";
import { scrollToElement } from "@/utils/scroll";
import { adjustStringAnchor } from "@/utils/slug";

type Props = {};

const DesktopCategoryBar = (props: any) => {
  return (
    <div className="backdrop-blur-xs border-t-1 sticky top-[76px] z-[4] mb-12 border-secondary-800 bg-secondary-300/80 py-4 backdrop-blur-md">
      <div className="container mx-auto flex flex-row items-center gap-4 divide-x divide-secondary/40 px-6">
        <h4 className="leading-7 text-secondary-800/80">Alle Artikel</h4>
        <div className=" flex flex-wrap items-center justify-start gap-2 pl-4 ">
          {Object.keys(props).map((key, index) => {
            return (
              <span
                className="blend cursor-pointer  bg-white px-2 py-0.5 text-sm font-semibold text-secondary/80 "
                onClick={() => {
                  scrollToElement(adjustStringAnchor(key), 120);
                }}
              >
                {key}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DesktopCategoryBar;
